import {
  getNewsContent,
  activeNewsReadCount,
  getNewsArticles,
  getMiniQrCode,
  getActivityList
} from '@/api'
import share from '@/mixins/share-finder.js'
import {formatTime} from '@/filters/index.js'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapState: mapArticleState } = createNamespacedHelpers('article')
import { mapState, mapMutations } from 'vuex'
import photoSwipe from '@/mixins/photoSwipe.js'
import url from 'url'
import {getStorage, removeStorage} from '@/utils/storage.js'
import bus from '../../utils/bus'
import { queryTemplateConfigInfoApi } from '../../api/services/launcher-user'

export default {
  name: 'articles',
  mixins: [share, photoSwipe],
  data() {
    return {
      articleInfo: {
      },
      article: {
        title: ''
      },
      isShowComment: false,
      isRender: true,
      timer: null,
      columnCode: '',
      columnName: '图文消息',
      showActivity:false,
      activityInfo: {},
      showMask: false,
      miniprogramPic: '',
      enterTime: 0, //文章详情进入时间
      isOver: false
    }
  },
  filters: {
    formatTime
  },
  computed: {
    ...mapGetters(['cacheArticleHtml']),
    ...mapArticleState(['cacheArticle']),
    ...mapState(['wechatUser', 'serviceConfig','investId']),
    title() {
      let urlTitle = this.serviceConfig.projectName
      if (urlTitle) {
        return urlTitle
      }
      return ''
    }
  },
  components:{
    Comment: () => import('@/components/launcher-comment/index.vue'),
    PhotoSwipe: () => import('@/components/PhotoSwipe.vue')
  },
  async created() {
    // console.log('created')
    // console.log('articleInfo组件：created')
    console.log('???', this.$route.query)
    this.setDocumentTitle(this.title)
    this.enterTime = Date.now()
    this.isRender = true
    if(this.cacheArticleHtml) {
      this.articleInfo = this.cacheArticle
    } else {
      const type = this.$route.params.type
      if(type.length === 32) {
        this.columnCode = this.$route.query.columnName || ''
        await this.getArticleInfo(type)
      } else {
        this.columnCode = type
        await this.getNewsArticles(type)
      }
    }
    this.isRender = false
    let query = url.parse(window.location.toString(), true).query
    let {key = '', source = '', brokerCode = '', shareFromUnionId = '', columnName} = query

    // fix sa-sdk loaded
    bus.$on('sa inited', () => {
      if (key === 'wechat-common-htz') { // 慧投资公众号
        if (this.articleInfo.newsId === '76962bccb72fe1e86be7d55d03a160a5') { // 生产【下载慧投资app】
          this.$sa.trackSaEn('enter_downloadpage')
        }
      }
      // TODO 文章阅读事件
      let data = {
        source: source || 'push',
        column_id: this.columnCode,
        column_name: this.columnName,
        news_id: this.articleInfo && this.articleInfo.newsId || '',
        title: this.articleInfo && this.articleInfo.title || '',
        publisher_id: this.articleInfo.author && this.articleInfo.author.id || '',
        publisher_name: this.articleInfo.author && this.articleInfo.author.name || '',
        adviser_id: brokerCode,
        pre_union_id: shareFromUnionId,
        subject_id: '', // 专题id
        subject_name: '', // 专题名称
        url: location.href
      }
      this.$sa.trackSaEn('view_article', data)
    })
    // 获取订阅模板数据的方法
    await this.getAndSetTemplateConfigInfo(columnName)
  },
  mounted() {
    let query = url.parse(window.location.toString(), true).query
    let {key = '', source = ''} = query
    setTimeout(() => {
      if((key === 'wechat-common-tthj' || key === 'wechat-common-ttj') && getStorage('INVEST_ID')) {
        this.getActivityPic()
        this.getMiniQrCode(getStorage('INVEST_ID'))
      }
    },2000);

    this.timer = setInterval(() => {
      const iframe = window.document.querySelector('.iframe')
      this.initMedia(iframe)
      this.handleImageClick()
    }, 1000)

    this.$nextTick(() => {
      window.addEventListener('scroll', (e) => {
        let dom = e.srcElement || e.target
        if (this.isOver) return
        const {clientHeight, scrollHeight, scrollTop} = dom
        if (scrollTop >= scrollHeight - clientHeight) {
          console.log('到底了。。。')
          this.isOver = true
          let data = {
            source: source || 'push',
            news_id: this.articleInfo.newsId || '',
            title: this.articleInfo.title || '',
          }
          this.$sa.trackSaEn('hit_article_bottom', data)
        }
      }, true)
    })
  },
  destroyed: function () {
    clearInterval(this.timer)
    window.removeEventListener('scroll')
  },
  beforeDestroy() {
    // 离开文章详情 神策打点
    let endTime = Date.now()
    let query = url.parse(window.location.toString(), true).query
    let {source = '', brokerCode = ''} = query
    let data = {
      source: source || 'push',
      news_id: this.articleInfo.newsId || '',
      title: this.articleInfo.title || '',
      adviser_id: brokerCode,
      staytime: Math.floor((endTime - this.enterTime)/1000)
    }
    this.$sa.trackSaEn('exit_article_detail', data)
  },
  methods: {
    ...mapMutations(['SET_SERVICE_CONFIG']),
    setDocumentTitle(title) {
      document.title = title
      let i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(() => {
          i.remove()
        }, 0)
      }
      document.body.appendChild(i)
    },
    closeActivity(){
      this.showActivity = false
    },
    async getActivityPic () {
      let params = {
        activityType:'MARKETING',
        applicationCode:'com.rjhy.venus',
        position:'tthj.xcx.wz.icon',
        hiddenStatus:'SHOWN',
        activityStatus:'NOW'
      }
      const res = await getActivityList(params)
      console.log(res)
      if(res&&res.code === 0 && res.data.list.length) {
        this.activityInfo = res.data.list[0]
        this.showActivity = true
      }
    },
    hideMask () {
      this.showMask = false
    },
    ToShowMask () {
      this.showMask = true
    },
    async getMiniQrCode (scene) {
      const env = process.env.VUE_APP_WEB || 'local'
      const originId = {
        'local': 'gh_1d02287d1815',
        'production': 'gh_2f65b828b5bc'
      }[env]

      // 小程序码只有生产可测试，直接用生产的originId
      let params = {
        originId,
        page: 'pages/home/index',
        scene
      }
      const res = await getMiniQrCode(params)
      if(res.data.code === 0){
        this.miniprogramPic = `data:image/png;base64,${res.data.result}`
        removeStorage('INVEST_ID')
      }
    },
    initMedia(iframe) {
      if(!iframe) return;
      clearInterval(this.timer)
      if(this.$route.query.isScroll) this.scrollToComment()
      this.handleAudio()
      this.handleVideo()
      this.handleAudioDeprecated()
      this.hideImg()
      this.adaptStyle()
      this.isShowComment = true
    },
    async getNewsArticles(type) {
      const {data: {code, data}} = await getNewsArticles(type, this.serviceConfig.appCode)
      if(code !== 1) return this.$message('服务报错');
      if(data.length === 0) return;
      let newsId = data[0].newsList[0] && data[0].newsList[0].newsId
      await this.getArticleInfo(newsId)
    },
    async getArticleInfo(articleId) {
      const {data: {code, data}} = await getNewsContent(articleId, this.serviceConfig.appCode)
      if(code !== 1) return this.$message('服务报错');
      if(data && data.content) {
        activeNewsReadCount(data.newsId, this.serviceConfig.appCode)
        data.content = data.content.replace(/(\<em\ id\=\"publish_time\"\ class\=\"rich_media_meta\ rich_media_meta_text\"\>).*?(\<\/em\>)/, function() {
          return `<em id="publish_time" class="rich_media_meta rich_media_meta_text">${formatTime(data.publishTime, 'yyyy-mm-dd')}</em>`
        })
        data.content = data.content.replace(/<[^video][^<>]*?>/gi, match => {
          return match.replace(/width="\d+"/gi, '')
        })
        data.content = data.content.replace(/[^-]width\:(.+?)px/gi, (match, p1) => {
          const clientWidth = document.getElementById('app').clientWidth
          if (Number(p1) > clientWidth) {
            return 'width: 100%'
          }
          return match
        })
        if (data.content.indexOf('<section style="font-size:16px;padding:20px 16px 12px;">') === -1) {
          data.content = `<section style="font-size:16px;padding:20px 16px 12px;">${data.content}</section>`
        }
      } else {
        data.content = undefined
      }
      this.articleInfo = data
      this.$store.dispatch('article/set_cache_article', data)
      if(this.articleInfo) {
        const column = this.articleInfo.columnBeans.find(i => i.code === this.columnCode)
        this.columnName = (column && column.name) || this.columnName
        let columnCode = this.$route.query.columnCode || this.articleInfo.columnBeans.map(i => i.code).join(',')
        this.articleInfo.columnName = this.columnName
        let type = ''
        if(this.articleInfo.dataType === 3) {
          type = 'article'
        }
        if(this.articleInfo.dataType === 4) {
          type = 'video'
        }
        this.$store.dispatch('set_share_info', {
          name: this.serviceConfig.projectName,
          title: data.title,
          desc: data.introduction,
          imgUrl: data.attribute.listImageUrl,
          articleType: type,
          columnName: this.articleInfo.columnName,
          cb: this.onMenuShare,
        })
        this.$behavior.track({
          eventName: 'article_read',
          properties: {
            article_title: this.articleInfo.title,
            article_title_news_id: this.articleInfo.newsId,
            article_type: this.columnName,
            article_code: columnCode
          }
        })
      }
    },
    scrollToComment() {
      const article = document.querySelector('.article')
      const iframe = window.document.querySelector('.iframe')
      const comment = window.document.querySelector('.comment')
      const header = comment.querySelector('.header')
      let timer = setTimeout(() => {
        article.scrollTop = iframe.offsetHeight + header.offsetHeight/2
        clearTimeout(timer)
      },2000)
    },
    handleAudio() {
      let _this = this
      const audioControllers = [].slice.call(document.querySelectorAll('.share_audio_context'))
      if (!audioControllers.length) return
      audioControllers.map(v => {
        formatAudio(v)
      })
      function formatAudio(audioController) {
        const share_audio_length_total = audioController.querySelector(".share_audio_length_total")
        if(!audioController) return;
        const progress = audioController.querySelector('.share_audio_progress_inner')
        const currentTime = audioController.querySelector('.share_audio_length_current')
        let timer
        if (!audioController) return

        const audio = audioController.querySelector('audio')
        audio.load()
        audio.oncanplay = function () {
          share_audio_length_total.innerHTML = _this.formatTime(audio.duration)
        }
        const reset = () => {
          clearTimeout(timer)
          audio.currentTime = 0
          currentTime.textContent = _this.formatTime(0)
          progress.style.width = 0
          audioController.classList.remove('share_audio_playing')
        }

        audio.addEventListener('ended', () => {
          reset()
          _this.$sa.trackSaEn('finish_audio', {
            audio_id: '',
            audio_url: audio.src || '',
            news_id: _this.articleInfo.newsId,
            duration: audio.duration
          })
        })

        audioController.addEventListener('click', () => {
          if (audio.paused) {
            audio.play()
            audioController.classList.add('share_audio_playing')
            timer = setInterval(() => {
              currentTime.textContent = _this.formatTime(audio.currentTime)
              progress.style.width = audio.currentTime / audio.duration * 100 + '%'
            }, 1000)
            _this.$sa.trackSaEn('click_play', {
              audio_id: '', // 音频id,
              audio_url: audio.src || '',
              news_id: _this.articleInfo.newsId
            })
          } else {
            audio.pause()
            _this.$sa.trackSaEn('click_pause', {
              audio_id: '',
              audio_url: audio.src || '',
              news_id: _this.articleInfo.newsId
            })
            reset()
          }
        })
      }
    },
    handleVideo() {
      const videoFrames = [].slice.call(document.querySelectorAll('.editor-video-content'))
      if (!videoFrames.length) return
      videoFrames.map(v => {
        resizeVideo(v)
      })
      function resizeVideo(videoFrame) {
        const aspectRatio = videoFrame.height / videoFrame.width
        videoFrame.height = videoFrame.clientWidth * aspectRatio
        videoFrame.style.height = videoFrame.height + "px"
        videoFrame.style.display = 'block'
        videoFrame.style.margin = '0 auto'
      }
    },
    handleAudioDeprecated() {
      const audioController = document.querySelector('mpvoice+span')
      if (!audioController) return
      const audio = document.createElement('audio')
      const mediaid = audioController.id.replace(/^voice_main_(.*?)_0$/, (total, main) => main)
      audio.src = 'https://res.wx.qq.com/voice/getvoice?mediaid=' + mediaid
      audio.style.cssText = 'height:0;width:0;display:none'
      document.body.appendChild(audio)
      audioController.addEventListener('click', function () {
        if (audio.paused) {
          audio.play()
          audioController.classList.add('playing')
        } else {
          audio.pause()
          audioController.classList.remove('playing')
        }
      })
    },
    hideImg(){
      const img_loadings = document.querySelectorAll('.img_loading')
      const l = img_loadings.length
      for(let x = 0; x < l;x ++) {
        img_loadings[x].removeAttribute('data-src')
      }
    },
    adaptStyle() {
      const imgController = document.querySelectorAll('img')
          , aController = document.querySelectorAll('a')
      for(let x of imgController) {
        const imgStyle = x.style
        imgStyle.maxWidth = '100%'
        imgStyle.height = 'auto'
      }
      for(let x of aController) {
        x.style.color = 'grey'
      }
    },
    formatTime (value) {
      const val = Math.round(value)
      let min = Math.floor(val / 60)
      if (min < 10) {
        min = '0' + min
      }
      let sec = val % 60
      if (sec < 10) {
        sec = '0' + sec
      }
      return `${min}:${sec}`
    },
    browser() {
      return {
        versions:function(){
            var u = navigator.userAgent
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq" //是否QQ
            };
        }(),
        language:(navigator.browserLanguage || navigator.language).toLowerCase()
      }
    },
    formatSubscribeHtml(src) {
      return `<img class="subscribe-image" src="${src || 'https://upload.techgp.cn/production/lib/images/subscribe.gif'}"/>`
    },
    // 获取模板及按钮信息并更新到serviceConfig中
    async getAndSetTemplateConfigInfo(columnCode) {
      // 图片存在则不需要重新拉取
      if (this.serviceConfig.button) return
      const params = {
        columnCode: columnCode || this.$route.query.columnName,
        originId: this.serviceConfig.originId
      }
      const res = await queryTemplateConfigInfoApi(params)
      if (res.code === 1 && res.data && res.data.templateId) {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: res.data.templateId,
          button: res.data.button
        })
      } else {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: '',
          button: ''
        })
      }
    }
  }
}
